import React, { FC, useEffect } from "react";
import PropTypes from "prop-types";
import { useGlobalContext } from "./ScanViewerContext";

import SwitchIcon from "../assets/switch.png";

import styles from "./scanSwitch.module.scss";
import MobilePortal from "../components/MobilePortal/MobilePortal";

type Props = {
  isMobile?: boolean;
};

const ScanSwitch: FC<Props> = ({ isMobile }) => {
  const { isMobileOnLandscape, stateMachineState, stateMachineSend } =
    useGlobalContext();

  return (
    <MobilePortal
      elementId={
        isMobileOnLandscape ? "mobileBottomCurtain" : "mobileTopCurtain"
      }
    >
      <div
        data-cy="cardScanAutoSwitch"
        className={`${styles.cardScanAutoSwitch} ${
          stateMachineState.context.autoScan ? "" : styles.cardScanSwitchOff
        } ${
          isMobile
            ? isMobileOnLandscape
              ? styles.cardScanAutoSwitchMobileLandscape
              : styles.cardScanAutoSwitchMobile
            : ""
        }`}
        onClick={() => stateMachineSend("TOGGLE")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            stateMachineSend("TOGGLE");
          }
        }}
        aria-label="Auto scan switch"
      >
        <img
          className={stateMachineState.context.autoScan ? styles.on : ""}
          src={SwitchIcon}
          alt={`camera lens icon `}
          style={{ height: "auto", width: "20%", aspectRatio: "1/1" }}
          draggable={false}
        />
        {stateMachineState.context.autoScan ? "Auto" : "Off"}
      </div>
    </MobilePortal>
  );
};

ScanSwitch.propTypes = {
  isMobile: PropTypes.bool,
};

export default ScanSwitch;
